export class ConsistencerBreakCycles {
    parent;
    constructor(parent) {
        this.parent = parent;
    }
    get app() {
        return this.parent.app;
    }
}
